import { cookieStorage, createStorage } from 'wagmi'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'

export const bsc = {
    id: 56,
    name: 'Binanace',
    network: 'bsc',
    rpcUrls: {
        default: 'https://bsc-dataseed1.bnbchain.org',
        public: 'https://bsc-dataseed1.bnbchain.org',
    },
    blockExplorers: {
        default: { name: 'BaseScan', url: 'https://bscscan.com/' },
    },
    multicall: {
        address: '0xcf591ce5574258ac4550d96c545e4f3fd49a74ec',
        blockCreated: 7162653,
    },
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
    },
}

const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604'


if (!PROJECT_ID) {
    throw new Error('Project ID is not defined')
}

//Set up the Wagmi Adapter (Config)
export const wagmiAdapter = new WagmiAdapter({
    storage: createStorage({
        storage: cookieStorage
    }),
    ssr: true,

    projectId: PROJECT_ID,
    networks: [bsc]
})

export const config = wagmiAdapter.wagmiConfig